import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { UserService } from './user-service';
declare var ga: any;
declare var DobryKantor: any;

@Component({
    selector: 'dk-user-login-status',
    template: require('./user-login-status.html')
})

export class UserLoginStatusComponent implements OnInit {
    accountEmail: string;
    accountDailyLimit: boolean;
    buyRebate: number;
    buyDefaultRebate: number;
    DobryKantor: any;
    showRebate = true;
    showRebateInfo = true;

    constructor(private userService: UserService) {
        this.DobryKantor = DobryKantor;
        this.showRebateInfo = DobryKantor.params.cantor.version=='dobrykantor'
    }

    ngOnInit() {
        this.userService
            .account()
            .subscribe(account => {
                this.accountEmail = account.Email;
                this.accountDailyLimit = account.DailyTransactionLimit;
                ga('set', 'userId', account.Id);
            });
        this.userService
            .getRebate()
            .subscribe(result => {
                if (result === false)
                {
                    this.showRebate = false;
                }

                this.buyRebate = this.formatRebate(result.buyRebate);
                this.buyDefaultRebate = this.formatRebate(result.buyDefaultRebate);
            });
    }

    logout() {
        this.userService.logout().subscribe(() => {
            location.href = DobryKantor.params.cantor.topUrl;
        })
    }

    public get isTransactionLimit() {
        return this.accountDailyLimit;
    }
    
    public get isRabatVisible() {
        return this.showRebate;
    }

    private formatRebate(rebate: number) {
        if (rebate) {
            return Math.abs(rebate) * 100;
        }

        return 0;
    }
}
